import React from 'react';

import cx from 'classnames';
import { omit } from 'ramda';

import TooltipDialog from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/Event/ModalContents/TooltipDialog';
import Button from 'components/shared/Button';
import { showErrorSnackbar } from 'hooks/useSnackbar';

import cs from '../../index.module.css';
import { SaveInfoButton, SaveInfoTooltip } from '../../TripEventModalContents/shared';
import { useDefaultValuesMutation } from '../../TripEventModalContents/shared/useDefaultValuesMutation';
import { useAccomodationFormContext } from '../AccomodationForm/hooks';
import { SaveButton } from './SaveButton';

const safeInfoTooltipId = 'safe_info_accommodation_tooltip';

export const AccommodationButtonGroup = function () {
  const { methods, isDisabled, isEditing } = useAccomodationFormContext();

  const tripEventId = methods.watch('id');
  const defaultValuesMutation = useDefaultValuesMutation();

  const handleSafeValues = (isForTeam?: boolean) => {
    try {
      const values = methods.getValues();

      const pageId = values.attachedPage?.id;
      const pageName = values.attachedPage?.name;

      if (!pageId && !pageName) throw new Error('Content Page is required');

      const defaultValues = {
        icon: values.icon,
        data: {
          ...omit(['isAlternate', 'confirmationNumber'], values.data),
          rooming: values.data.rooming.map((rooming) => ({
            id: rooming.value,
            name: rooming.label,
            count: rooming.count,
          })),
        },
      };
      defaultValuesMutation.mutate({
        pageName,
        pageId: pageId,
        eventType: values.type,
        defaultValues,
        wholeTeam: isForTeam,
      });
    } catch (e) {
      let errorMessage = 'Failed to save information';
      if (e instanceof Error) errorMessage = e.message;

      showErrorSnackbar(errorMessage);
      console.error(e);
    }
  };

  return (
    <React.Fragment>
      <div className={cx(cs.footer, cs.improvedUIOnEventModalsFeature)}>
        <SaveInfoButton
          disabled={isDisabled}
          handleSaveForMyself={() => handleSafeValues(false)}
          handleSaveForTeam={() => handleSafeValues(true)}
          tooltipId={safeInfoTooltipId}
        />

        <div className={cs.rightFooter}>
          {isEditing && (
            <TooltipDialog tripEventId={tripEventId} onSubmit={() => {}}>
              <Button type="primary2" className={cs.buttonText} size="large" htmlType="button">
                Remove
              </Button>
            </TooltipDialog>
          )}

          <SaveButton />
        </div>
      </div>

      <SaveInfoTooltip tooltipId={safeInfoTooltipId} />
    </React.Fragment>
  );
};
